import styled from 'styled-components'

interface IEmptyStateStyledProps {
  small?: boolean
}

export const EmptyStateStyled = styled.div<IEmptyStateStyledProps>`
  font-size: ${(props) =>
    props.small
      ? props.theme.typography.pxToRem(props.theme.fontSizes.body2)
      : props.theme.typography.pxToRem(props.theme.fontSizes.body1)};

  margin: ${(props) => props.theme.space.medium};
  padding: ${(props) => props.theme.space.large};

  text-align: center;
`
